import { createAppAsyncThunk } from "@myRedux/createAppAsyncThunk";
import { handleSliceRejectionDefault } from "@myRedux/handleSliceRejection";
import { ApiCall, ApiCallStatus } from "@myRedux/networkState";
import { RootState } from "@myRedux/store";
import { createSlice } from "@reduxjs/toolkit";
import { getErrorMessage } from "app/error";
import { ACCESSTOKENLOCALSTORAGE, OAUTHGOOGLECSRFTOKEN } from "app/localStorage";

export interface OAuthResponse {
  redirectUrl: string
}

const initialState = {
  status: ApiCallStatus.Idle,
} as ApiCall;

export const authenticateGoogleUser = createAppAsyncThunk(
  'oauth/google/authenticate',
  async (arg: string, thunkAPI) => {
    try {
      const response = await thunkAPI.extra.authClient.post(`oauth/google/authenticate`, { code: arg });
      if (response.hasError()) {
        return thunkAPI.rejectWithValue(response.statusText);
      }
      return response.data;
    }
    catch (error) {
      return thunkAPI.rejectWithValue(getErrorMessage(error));
    }
  }
)

export const authenticateSlice = createSlice({
  name: 'authenticateSlice',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(authenticateGoogleUser.pending, (state) => {
        state.status = ApiCallStatus.Loading;
        localStorage.removeItem(OAUTHGOOGLECSRFTOKEN);
      })
      .addCase(authenticateGoogleUser.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
        localStorage.setItem(ACCESSTOKENLOCALSTORAGE, action.payload.accessToken);
      })
      .addCase(authenticateGoogleUser.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
        handleSliceRejectionDefault(action);
      });
  },
});

export const selectGoogleAuthenticate = (state: RootState) => state.oauth.google.authenticate;

export default authenticateSlice.reducer;